import styled from 'styled-components';

export const FilterListWrapper = styled.div`
  display: block;
  padding-bottom: 50px;
`;

export default FilterListWrapper;
